document.addEventListener('DOMContentLoaded', function () {
  // Homepage Slideshow
if (document.querySelector('.homepage-slideshow')) {
  $('.homepage-slideshow').each(function () {
    var slider = $(this);
    slider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: slider.data('dots') === true || slider.data('dots') === 'true',
      arrows: slider.data('arrows') === true || slider.data('arrows') === 'true',
      autoplay: slider.data('autoplay') === true || slider.data('autoplay') === 'true',
      autoplaySpeed: parseInt(slider.data('speed')) || 3000
    });
  });
}

// Category Carousel Slider
if (document.querySelector('.category-carousel-slider')) {
  $('.category-carousel-slider').each(function () {
    var slider = $(this);
    slider.slick({
      infinite: true,
      slidesToShow: parseInt(slider.data('desktop')) || 6,
      slidesToScroll: 1,
      dots: slider.data('dots') === true || slider.data('dots') === 'true',
      arrows: slider.data('arrows') === true || slider.data('arrows') === 'true',
      autoplay: slider.data('autoplay') === true || slider.data('autoplay') === 'true',
      autoplaySpeed: parseInt(slider.data('speed')) || 3000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: parseInt(slider.data('tablet')) || 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: parseInt(slider.data('mobile')) || 2
          }
        }
      ]
    });
  });
}

// Featured Collection Slider (Old theme style)
if (document.querySelector('.product-carousel-4_2')) {
  $('.product-carousel-4_2').each(function () {
    var slider = $(this);
    slider.slick({
      infinite: true,
      slidesToShow: parseInt(slider.data('desktop')) || 4,
      slidesToScroll: 1,
      dots: slider.data('dots') === true || slider.data('dots') === 'true',
      arrows: slider.data('arrows') === true || slider.data('arrows') === 'true',
      autoplay: slider.data('autoplay') === true || slider.data('autoplay') === 'true',
      autoplaySpeed: parseInt(slider.data('speed')) || 3000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: parseInt(slider.data('tablet')) || 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: parseInt(slider.data('mobile')) || 1
          }
        }
      ]
    });
  });
}

if (document.querySelector('.testimonial-slider')) {
  $('.testimonial-slider').slick({
    centerMode: true,
    centerPadding: '40px',
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          centerPadding: '20px'
        }
      }
    ]
  });
}

// Product Gallery Slider (desktop = fade, mobile = center card)
if (document.querySelector('.product-large-slider')) {

  function destroyGallerySliders() {
    if ($('.product-large-slider').hasClass('slick-initialized')) {
      $('.product-large-slider').slick('unslick');
    }
    if ($('.pro-nav').hasClass('slick-initialized')) {
      $('.pro-nav').slick('unslick');
    }
  }

  function initDesktopGallery() {
    // Desktop (your original)
    $('.product-large-slider').slick({
      fade: true,
      arrows: false,
      asNavFor: '.pro-nav'
    });

    $('.pro-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product-large-slider',
      focusOnSelect: true,
      vertical: true,
      arrows: false,
      prevArrow: '<button type="button" class="slick-prev-thumb"><i class="pe-7s-angle-up"></i></button>',
      nextArrow: '<button type="button" class="slick-next-thumb"><i class="pe-7s-angle-down"></i></button>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
            vertical: false,
            prevArrow: '<button type="button" class="slick-prev-thumb"><i class="pe-7s-angle-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next-thumb"><i class="pe-7s-angle-right"></i></button>'
          }
        }
      ]
    });
  }

  function initMobileCenterGallery() {
    // Mobile (center card like screenshot 1)
    $('.product-large-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      fade: false,
      centerMode: true,
      centerPadding: '22px',
      arrows: false,
      dots: false,
      adaptiveHeight: true
      // NOTE: no asNavFor on mobile (optional). If you want thumbs sync, tell me.
    });

    // Optional: keep thumbs hidden on mobile (recommended)
    $('.pro-nav').hide();
  }

  function initByViewport() {
    destroyGallerySliders();

    if (window.innerWidth <= 767) {
      initMobileCenterGallery();
    } else {
      $('.pro-nav').show();
      initDesktopGallery();
    }
  }

  // init on load
  initByViewport();

  // re-init on resize (debounced)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initByViewport, 250);
  });
}

});
